import api from "./axios";

const authHeaders = (token) => ({
  headers: { Authorization: `Bearer ${token}` },
});

export const getTranslations = (token, params = {}) => api.get("/translation", { ...authHeaders(token), params });
export const getTranslation = (id, token) => api.get(`/translation/${id}`, authHeaders(token));
export const createTranslation = (data, token) => api.post("/translation/create", data, authHeaders(token));
export const updateTranslation = (id, data, token) => api.put(`/translation/${id}`, data, authHeaders(token));
// export const deleteTranslation = (id, token) => api.delete(`/translation/source/${id}`, authHeaders(token));